<template>
  <div class="row relative-position q-py-sm justify-center">
    <div
      v-if="background"
      :style="{ 'min-height': backgroundHeight }"
      :class="`background-offset bg-${background}`"
    />
    <div class="desktop-single-column full-width row q-py-sm q-px-md z-1">
      <BtnBack
        :color="backColor"
        :icon-size="backSize"
        :label="backLabel"
        @click="$emit('back')"
      />
      <div class="row col items-center">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PageBack',
  props: {
    backColor: {
      type: String,
      default: 'grey-9'
    },
    backSize: {
      type: String,
      default: '20px'
    },
    backLabel: String,
    background: String,
    backgroundHeight: {
      type: String,
      default: '125px'
    }
  },
  components: {
    BtnBack: () => import('../../atom/btn-back')
  }
};
</script>

<style lang="sass" scoped>
.background-offset
  position: absolute
  top: 0
  left: 0
  right: 0
  height: 150%
</style>
